import React, { FC } from 'react'
// import './styles.scss'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/grid.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/card.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
// import '@ta-interaktiv/semantic-ui/semantic/dist/components/icon.css'
import styled from 'styled-components'
import ContentGrid from 'components/ContentGrid'
import { ContentWidth, TextWidth } from 'components/Container'
import dataCards from './daten.json'

// console.log('test', dataCards)

export const Cards: FC<{
  title?: string
  lead?: string
  width?: 'full' | 'content' | 'text'
  caption?: string
  source?: string
  colorMode?: string
  legendRanking?: string
}> = ({ title, lead, width, caption, source, colorMode, legendRanking }) => {
  return (
    <>
      <ContentGrid>
        <TextWidth>
          <>
            {title && <Title>{title}</Title>}
            {lead && <Lead className='lead'>{lead}</Lead>}
          </>
        </TextWidth>
      </ContentGrid>
      <ContentGrid>
        <TextWidth>
          {colorMode === 'dark' ? (
            <Legend>
              <div className='legendWrapper'>
                <div className='entry'>
                  <div>
                    <div className='legendColor'></div>
                  </div>
                  <div>{legendRanking}</div>
                </div>
                <img
                  src={require(`./legend_dark.png`)}
                  alt='graphic legend'
                  className='graphicLegend'
                ></img>
              </div>
            </Legend>
          ) : (
            <Legend>
              <div className='legendWrapper'>
                <div className='entry'>
                  <div>
                    <div className='legendColor'></div>
                  </div>
                  <div>{legendRanking}</div>
                </div>
                <img
                  src={require(`./legend.png`)}
                  alt='graphic legend'
                  className='graphicLegend'
                ></img>
              </div>
            </Legend>
          )}
        </TextWidth>
      </ContentGrid>

      {width === 'full' && (
        <>
          <CardsContainer>
            {/* <div className='rankingWrapper'>
              <img
                src={require(`./arrow.png`)}
                alt='arrow ranking info'
                className='arrow'
              ></img>
              <div className='rankingInfo'>{rankingInfo}</div>
            </div> */}

            <div className='ui cards'>
              {dataCards.map(
                (
                  item: {
                    rank?: string | number
                    map?: number
                    mapDark?: string
                    year?: number
                    colorRank?: string
                  },
                  index: number
                ) => {
                  return (
                    <div className='card' key={index}>
                      <div className='imageContainer '>
                        {item.rank !== '' ? (
                          <div className='row'>
                            <div
                              className={
                                'rank ' +
                                item.colorRank +
                                (colorMode === 'dark' ? ' dark' : '')
                              }
                            >
                              {item.rank}
                            </div>
                          </div>
                        ) : (
                          <div className='row'>
                            <div className='rank empty'></div>
                          </div>
                        )}
                        <div className='row'>
                          {colorMode === 'dark' ? (
                            <Image
                              src={require(`./icons/${item.mapDark}.png`)}
                            ></Image>
                          ) : (
                            <Image
                              src={require(`./icons/${item.map}.png`)}
                            ></Image>
                          )}
                        </div>
                        <div className='row year'>
                          <div
                            className={
                              'year' + (colorMode === 'dark' ? ' dark' : '')
                            }
                          >
                            {item.year}
                          </div>
                        </div>
                      </div>
                    </div>
                  )
                }
              )}
            </div>
          </CardsContainer>
        </>
      )}

      {width === 'content' && (
        <>
          <ContentGrid>
            <ContentWidth>
              <CardsContainer>
                {/* <div className='rankingWrapper'>
                  <img
                    src={require(`./arrow.png`)}
                    alt='arrow ranking info'
                    className='arrow'
                  ></img>
                  <div className='rankingInfo'>{rankingInfo}</div>
                </div> */}

                <div className={'ui cards'}>
                  {dataCards.map(
                    (
                      item: {
                        rank?: string | number
                        year?: number
                        map?: number
                        mapDark?: string
                        colorRank?: string
                      },
                      index: number
                    ) => {
                      return (
                        <div className='card' key={index}>
                          <div className='imageContainer '>
                            {item.rank !== '' ? (
                              <div className='row'>
                                <div
                                  className={
                                    'rank ' +
                                    item.colorRank +
                                    (colorMode === 'dark' ? ' dark' : '')
                                  }
                                >
                                  {item.rank}
                                </div>
                              </div>
                            ) : (
                              <div className='row'>
                                <div className='rank empty'></div>
                              </div>
                            )}

                            <div className='row'>
                              {colorMode === 'dark' ? (
                                <Image
                                  src={require(`./icons/${item.mapDark}.png`)}
                                ></Image>
                              ) : (
                                <Image
                                  src={require(`./icons/${item.map}.png`)}
                                ></Image>
                              )}
                            </div>
                            <div className='row year'>
                              <div
                                className={
                                  'year' + (colorMode === 'dark' ? ' dark' : '')
                                }
                              >
                                {item.year}
                              </div>
                            </div>
                          </div>
                        </div>
                      )
                    }
                  )}
                </div>
              </CardsContainer>
            </ContentWidth>
          </ContentGrid>
        </>
      )}
      <ContentGrid>
        <ContentWidth>
          <Caption>
            {caption && caption}
            {source && <Source>{source}</Source>}
          </Caption>
        </ContentWidth>
      </ContentGrid>
    </>
  )
}

const Image = ({ src, className }: { src?: string; className?: string }) => {
  return (
    <img src={src} alt='icon' className={`ui fluid image + ${className}`}></img>
  )
}

const CardsContainer = styled.div<{ tenant?: string }>`
  /* overflow: hidden; */
  /* max-width: 1072px !important; */
  margin-left: auto;
  margin-right: auto;
  font-size: 18px;
  margin-top: 1em;
  .grid {
    margin: 0;
    padding: 0;
    width: 100%;
  }
  /* .grid > .column {
    box-shadow: 2px 2px 8px rgb(0 0 0 / 10%), 0 0 2px rgb(0 0 0 / 10%);
    border-radius: 5px;
  } */

  .cards {
    justify-content: start;
    width: 100%;
    margin: 0;
  }
  .cards > .card {
    /* box-shadow: 2px 2px 8px rgb(0 0 0 / 10%), 0 0 2px rgb(0 0 0 / 10%); */
    /* border-radius: 5px; */
    background-color: transparent;
  }

  .ui.cards > .card {
    /* margin: 0.5rem 0.25rem; */
    width: calc(100% / 10);
    margin: 0;

    @media only screen and (max-width: 1679px) {
      width: calc(100% / 8);
    }

    @media only screen and (max-width: 1071px) {
      width: calc(100% / 8);
    }

    @media only screen and (max-width: 711px) {
      width: calc(100% / 6);
    }

    @media only screen and (max-width: 599px) {
      width: calc(100% / 5);
    }

    @media only screen and (max-width: 420px) {
      width: calc(100% / 4);
    }

    /* height: 100%; */
  }

  .imageContainer {
    /* color: white; */

    padding: 0.25rem 0.25rem 0.5rem 0.25em;
    @media only screen and (max-width: 599px) {
      padding: 0.25rem 0.25rem 0.25rem 0.25em;
    }
    text-align: center;
    line-height: 1.3;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    img {
      width: 100%;
    }
  }

  /* .ui.cards > .card > .content {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .ui.cards > .card > .content::after {
    content: none;
  } */

  // RANKING
  /* .rankingWrapper {
    display: flex;
  }

  .arrow {
    width: 30px;
    padding-left: 116px;
    padding-bottom: 10px;
  }

  .rankingInfo {
    font-size: 0.9em;
    color: #555555;
  } */

  .row {
    .rank {
      position: absolute;
      top: -0.5rem;
      right: -0.5rem;
      margin-left: auto;
      z-index: 100;
      color: var(--text-color);
      font-size: 12px;
      font-weight: 700;
      @media only screen and (max-width: 749px) {
        font-size: 12px;
        width: 13px;
        height: 13px;
        line-height: 13px;
      }
      @media only screen and (max-width: 450px) {
        font-size: 11px;
        width: 12px;
        height: 12px;
        line-height: 12px;
      }
      @media only screen and (max-width: 320px) {
        font-size: 10px;
      }

      border-radius: 50%;
      width: 15px;
      height: 15px;
      padding: 2px;
      line-height: 15px;

      background: #fff;
      border: 1px solid #7d7d7d;
      color: #7d7d7d;
      text-align: center;
      background-color: transparent;
    }
    .rank.empty {
      border: none;
    }
    .rank.red {
      /* background: #6F7187; */
      border: 1px solid #67000d;
      color: #67000d;
    }

    .rank.red.dark {
      color: #ef3b2c;
      border: 1px solid #ef3b2c;
    }
    .rank.blue {
      /* background: #6F7187; */
      border: 1px solid #2171b5;
      color: #2171b5;
    }
    .rank.blue.dark {
      color: #6baed6;
      border: 1px solid #6baed6;
    }
  }

  .row.year {
    margin-top: 0.1rem;
    .year {
      font-size: 0.9em;
      color: #555555;
      @media only screen and (max-width: 711px) {
        font-size: 15px;
      }
      @media only screen and (max-width: 450px) {
        font-size: 14px;
      }
    }
    .year.dark {
      color: var(--gray-4);
    }
  }
`
const Legend = styled.div<{ tenant?: string }>`
  color: var(--text-color);
  font-size: 15px;
  /* margin-top: 1em; */

  .legendTitle {
    font-weight: 700;
    margin-bottom: 0.25em;
  }

  .legendWrapper {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    font-size: 1.5em;
    margin-bottom: 0.5em;
  }

  .entry {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: baseline;
    padding-right: 1rem;
    line-height: 2.3rem;
    font-size: 15px;
  }
  .legendColor {
    margin-right: 0.5rem;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    border: 1px solid var(--text-color);
  }
  .legendColor.red {
    border: 1px solid #9e272f;
  }
  .legendColor.blue {
    border: 1px solid #296a8d;
  }
  .graphicLegend {
    margin-right: auto;
    margin-left: auto;
    width: 400px;
    margin-top: 2rem;
    @media only screen and (max-width: 599px) {
      width: 90%;
    }
    @media only screen and (max-width: 374px) {
      width: 100%;
    }
  }
`
const Caption = styled.figcaption`
  color: var(--text-color);
  font-family: var(--font-sans-serif);
  font-size: 1.5rem;
  line-height: 2.1rem;
  margin-top: 1.5rem;

  /* &.top {
    margin-top: 1.5rem;
  }

  &.bottom.true {
    margin-top: 1.5rem;
  } */

  .source {
    margin-top: 0.5em;
    font-weight: 400;
    color: var(--gray-3);
    font-size: 1.2rem;
    line-height: 1.8rem;
  }
`
const Source = styled.div`
  margin-top: 0.5em;
  font-weight: 400;
  color: var(--gray-3);
  font-size: 1.2rem;
  line-height: 1.8rem;
  margin-bottom: 30px;
  /* &.bottom {
    margin-top: 0.3rem;
  } */
`

const Title = styled.h3`
  color: var(--text-color);
  margin: 0;
  font-size: 18px !important;
  line-height: 2.4rem;
  margin-bottom: 2rem;

  &.bottom {
    margin-top: 1.5rem;
    font-size: 1.5rem !important;
    line-height: 2.1rem;
    margin-bottom: 0;
  }
`
const Lead = styled.div`
  color: var(--text-color);
  font-size: 15px;
  /* max-width: 668px; */
  font-style: normal;
  font-weight: 400;
  line-height: 2.3rem;
  margin: 0;
  margin-bottom: 2rem;
  &.bottom {
    line-height: 2.1rem;
    margin-bottom: 0;
  }
  &.top {
    margin-bottom: 1.5rem;
  }
`
